export default __webpack_public_path__ + "static/media/FrozenABC_12.6bb706de.png";